import React, { useEffect, useState, memo, useContext } from "react";
import { MapTools } from "../../constants/WebMap";
import { WebMapContext } from "../../pages/sections/web-map/WebMapGoogleMap";
import { ToolContainer } from "../styled/PanelTools.styled";
import SidePanelCard from "./StyledSidePanelCard";
import { LoadMapContext } from "../../pages/sections/web-map/LoadWebMap";
import PanelSingleTool from "./PanelSingleTool";
import PanelZoomLevel from "./PanelZoomLevel";

const toolsConstants = [
  {
    title: "Measure Distance",
    toolTip: "Measure Distance",
    action: MapTools.DISTANCE,
    img: "/assets/measuredistance.png"
  },
  {
    title: "Measure Area",
    toolTip: "Measure Area",
    action: MapTools.AREA,
    img: "/assets/measurearea.png"
  },
  {
    title: "Comparative Split",
    toolTip: "Comparative Split",
    action: MapTools.SPLIT,
    img: "/assets/split-screen.png"
  }, 
  {
    title: "Comparison Slider",
    toolTip: "Comparison Slider",
    action: MapTools.SLIDER,
    img: "/assets/slider.png"
  },
  {
    title: "Download Files",
    action: MapTools.FILE_DOWNLOAD,
    isSvg: true,
    isDropDown: true,
    options: [{name:"Pin",key:MapTools.DOWNLOAD_PIN}, {name:"Polygon",key:MapTools.DOWNLOAD_POLYGON}, {name:"Uploaded File",key:MapTools.DOWNLOAD_FROM_FILE}],
    img: 'downloadIcon'
  },
    {
    title: "Upload Files",
    action: MapTools.FILE_UPLOAD,
    isSvg: true,
    isDropDown: true,
    options: [{name:"Sites",key:MapTools.UPLOAD_SITES}, {name:"Polygons",key:MapTools.UPLOAD_POLYGONS}],
    img: 'uploadIcon'
  },
];

const toolswhenSplit = [
  {
    title: "Comparative Split",
    toolTip: "Comparative Split",
    action: MapTools.SPLIT,
    img: "/assets/split-screen.png"
  },
  {
    title: "Comparison Slider",
    toolTip: "Comparison Slider",
    action: MapTools.SLIDER,
    img: "/assets/slider.png"
  },
];

const PanelTools = ({ show, permissions }) => {
  const {
    appliedFilters,
    setToolMarkers,
    setMapTool,
    mapTool,
    mapPlacement,
  } = useContext(WebMapContext);

  const { setMapView, mapView } = useContext(LoadMapContext);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [selectedTool, setSelectedTool] = useState(null);
  const permittedTools = permissions?.filter((p) => p.is_enable === true)?.map((p) => p.name);
  const displayTools = toolsConstants.filter(element => permittedTools.includes(element.title));
  const splitTools = toolswhenSplit.filter(element => permittedTools.includes(element.title));
  const [tools, setTools] = useState(displayTools);

  useEffect(() => {
    if (mapPlacement !== 'right') {
      setToolMarkers([]);
      if (selectedTool === null) {
        setMapTool(selectedTool);
        setMapView(selectedTool);
      } else if (selectedTool === MapTools.SPLIT || selectedTool === MapTools.SLIDER) {
        setMapView(selectedTool);
        setMapTool(null);
      } else {
        setMapTool(selectedTool);
      }
    }
  }, [selectedTool])

  useEffect(() => {
    if (!appliedFilters.countryCode && mapPlacement !== 'right') setSelectedTool(null);
  }, [appliedFilters.countryCode]);

  const onDropDownClick = (e) => {
    setTools((prev) =>
      prev.map((tool) => {
        const hasOptions = tool?.options?.length > 0;
        const isCurrentTool = tool.action === e;

        if (hasOptions) {
          if (isCurrentTool) {
            setSelectedTool(null);
          }
          return {
            ...tool,
            isDropDownOpen: isCurrentTool ? !tool.isDropDownOpen : false,
          };
        }
        return tool;
      })
    );
  };

  const isSelected = (toolAction) => {
    const downloadTools = [
      MapTools.DOWNLOAD_PIN,
      MapTools.DOWNLOAD_POLYGON,
      MapTools.DOWNLOAD_FROM_FILE
    ];

    const uploadTools = [
      MapTools.UPLOAD_SITES,
      MapTools.UPLOAD_POLYGONS
    ];

    if (mapTool === toolAction) {
      return true;
    }

    if (downloadTools.includes(mapTool) && toolAction === MapTools.FILE_DOWNLOAD) {
      return true;
    }

    if (uploadTools.includes(mapTool) && toolAction === MapTools.FILE_UPLOAD) {
      return true;
    }

    return false;
  };

  return (
    <div
      hidden={!show}
      style={{
        overflow: "visible",
        overflowY: "auto",
        width: "100%",
        minHeight: isCollapsed ? "185px" : "0px",
      }}
    >
      {mapPlacement !== "right" && (
        <>
          <SidePanelCard
            title="Tools"
            icon={
              isCollapsed
                ? "/assets/webpaneltoolswhite.png"
                : "/assets/webpaneltools.png"
            }
            clicked={isCollapsed}
            onClick={() => setIsCollapsed(!isCollapsed)}
          />
          {isCollapsed ? (
            <>
              <ToolContainer>
                {(mapView === null ? tools : splitTools).map((tool) => (
                  <PanelSingleTool
                    toolTitle={tool?.title}
                    toolWidth={'18px'}
                    toolHeight={'18px'}
                    toolTip={tool?.toolTip}
                    handleClick={(action) =>{
                      //Reset dropdowns
                      onDropDownClick(null)
                      setSelectedTool(selectedTool === action ? null : action)
                    }}
                    isDropDownOpen={tool?.isDropDownOpen}
                    action={tool.action}
                    toolSelected={isSelected(tool.action)}
                    onClickDropdown={onDropDownClick}
                    toolImg={tool.img}
                    isDropDown={tool?.isDropDown}
                    options={tool?.options}
                    isSvg={tool?.isSvg}
                  />
                ))}
              </ToolContainer>
            </>
          ) : (
            <></>
          )}
        </>
      )}
      <PanelZoomLevel isCollapsed={isCollapsed} />
    </div>
  );
};

export default memo(PanelTools);